import { required } from '@vuelidate/validators';
import validationMixin from '@/mixins/validation-mixin';
import FormInput from '@/components/form/input';
import useVuelidate from '@vuelidate/core';

export default {

  setup() {
    return { v$: useVuelidate() };
  },
  emits: ['incremental-data-field:validation-error', 'incremental-data-field:submit'],
  mixins: [validationMixin],

  components: {
    FormInput,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    validateAll: {
      type: Boolean,
      default: false,
    },
    serverValidationErrors: {
      type: Object,
      default: () => ({}),
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },

  validations() {
    const rules = {
      fields: {
        [this.fieldName]: { required },
      },
    };

    return rules;
  },

  methods: {
    submit() {
      if (this.v$) {
        this.v$.$validate();
        if (this.v$.fields.$invalid) {
          this.$emit('incremental-data-field:validation-error');
          return;
        }

        this.$emit('incremental-data-field:submit', {
          payload: this.updatePayload,
          fieldName: this.fieldName,
        });
      }
    },
  },
};
